import { API } from './index';
import { ProfileSuccessResponse } from '@greatsumini/react-facebook-login';
import { ISessionCreateData, TelegramUserData } from '../interfaces';

export function loginByEmail(email: string, password: string) {
    return API.post('/auth/login-by-email', {
        email,
        password,
    });
}

export function registerByEmail(email: string, password: string) {
    return API.post('/auth/register-by-email', {
        email,
        password,
    });
}

export function sendVerificationCode(email: string, code: number): Promise<any> {
    return API.post('/auth/send-verification-code', {
        email,
        code,
    });
}

export function recoveryPassword(email: string): Promise<any> {
	return API.post('/auth/recovery-password', {
        email
    });
}

export function activateNewPassword(email: string, password: string): Promise<any> {
	return API.post('/auth/activate-new-password', {
        email,
        password,
	});
}

export function sendRecoveryPasswordCode(email: string, code: number): Promise<any> {
    return API.post('/auth/send-recovery-password-code', {
        email,
        code,
    });
}

export function checkAuth(jwt: string): Promise<any> {
    return API.get(`/auth/check/${jwt}`);
}

export function logout(): Promise<any> {
    return API.post('/auth/logout') ;
}

export function appleLogin(idToken: string): Promise<any> {
    return API.post('/auth/apple-login', {
        idToken,
    });
}

export function telegramLogin(userData: TelegramUserData): Promise<any> {
    return API.post('/auth/telegram-login', {
        userData
    });
}

export function facebookLogin(profile: ProfileSuccessResponse): Promise<any> {
    return API.post('/auth/facebook-login', {
        profile
    });
}

export function sessionGet(data: ISessionCreateData): Promise<any> {
    return API.post('/session/get', data);
}

export function googleLoginNative(accessToken: string): Promise<any> {
    return API.post('/auth/google-login-native', {
        accessToken
    });
}

export function checkUserAuthState(id: string): Promise<any> {
    return API.get(`/auth/check-user-auth-state/${id}`);
}

export function setUserAuthState(id: string): Promise<any> {
    return API.post('/auth/set-user-auth-state', {
        id
    });
}